var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",class:{
    checked: _vm.isChecked,
    'table-disabled-checkbox': !_vm.status,
  },attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }